import video from "assets/img/homepage/introduce-bg.mp4";
import logo from "assets/img/logo-short.svg";

const HomepageIntroduce = () => {
  return (
    <div className="homepage-introduce" id="introduce">
      <video
        src={video}
        autoPlay
        playsInline
        muted
        loop
        className="homepage-introduce__video"
      ></video>
      <section className="homepage-introduce__first">
        <h2 className="homepage__second-title">
          <span className="yellow">TwoTwentyK is Always Free-to-Play. </span>
          <span className="italic">Want to supercharge your experience?</span>
          <span className="yellow">Purchase card packs and play for</span>
          <span className="yellow">real-money rewards!</span>
        </h2>
      </section>
      <section className="homepage-introduce__second">
        <img src={logo} className="homepage-introduce__logo" alt="" />
      </section>
    </div>
  );
};

export default HomepageIntroduce;
